module.exports = __webpack_public_path__ + "img/user.9fcdbc2c.svg";